import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Panel, OverlayTrigger, Tooltip} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, addArrayItemField} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import TypeaheadGridInput, {matcher} from '../../core/components/TypeaheadGridInput'
import TagBar from '../../core/components/TagBar'
import Icon from '../../core/components/Icon'
import IconCateg from '../../core/components/IconCateg'
import {UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED, updateUpdateOpeningTicketPurposeAction, sendUpdateOpeningTicketPurposeAction, sendAddTagToOpeningTicketPurposeAction, sendRemoveTagFromOpeningTicketPurposeAction, sendAddCategoryToOpeningTicketPurposeAction, sendRemoveCategoryFromOpeningTicketPurposeAction, loadOpeningTicketPurposeRef} from '../actions'
import {OpeningTicketPurposeRef, UpdateOpeningTicketPurposeAction} from '../models'
import i18n from '../i18n'
import style from './UpdateOpeningTicketPurposePanel.less'

function childrenCategoryFilter(parentCategory) {
    return (category) => {
        return (category.parent && category.parent.uid) == (parentCategory && parentCategory.uid)
    }
}

function categoryAggregator(reference) {
    return (result, category) => {
        const resultCategory =  reference.categories.find((c) => c.uid == category.uid)

        if (resultCategory) {
            result.push(resultCategory)
        } else {
            console && console.warn('category "' + category.uid + '" doesn\'t exist in referentiel')
        }
        return result
    }
}

function tagAggregator(reference) {
    const defaultTag = reference.default.tag

    return (result, tag) => {
        if (defaultTag.uid == tag.uid) {
            result.push(defaultTag)
            return result
        }

        const resultTag = reference.tags.find((t) => t.uid == tag.uid)

        if (resultTag) {
            result.push(resultTag)
        } else {
            console && console.warn('tag "' + tag.uid + '" doesn\'t exist in referentiel')
        }
        return result    
    }
}

function activityAggregator(reference) {
    return (result, activity) => {
        const resultActivity =  reference.find((a) => a.uid == activity.uid)

        if (resultActivity) {
            result.push(resultActivity)
        } else {
            console && console.warn('activity "' + activity.uid + '" doesn\'t exist in referentiel')
        }
        return result
    }
}

function onPathFinder(reference, nodeCategory) {
    return (category) => {
        const categoryPath = OpeningTicketPurposeRef.expendParentCategories(reference, category)
        return !!categoryPath.find((c) => c.uid == nodeCategory.uid)
    }
}

function categoryTagMatcher(categoriesOrTags) {
    return matcher({
        source: categoriesOrTags,
        identify: (cot) => cot.label
    })
}

function openingTicketPurposeActionUpdate(openingTicketPurpose) {
    return {
        uid: openingTicketPurpose.uid || null,
        label: openingTicketPurpose.label || null,
        extId: openingTicketPurpose.extId || null
    }
}

class UpdateOpeningTicketPurposePanel extends Component {
    static propTypes = {
        openingTicketPurpose: PropTypes.object.isRequired,
        openingTicketPurposeReference: PropTypes.object.isRequired,
        activityReference: PropTypes.array.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)
        this._categoryTagBars = []
        this._categoryTypeaheadGridInputs = []

        this.state = {
            openingTicketPurposeCategories: [],
            openingTicketPurposeTags: [],
            openingTicketPurposeActivities: [],
            transientCategories: []
        }
    }

    componentWillMount() {
        const {dispatch, expanded, openingTicketPurpose, openingTicketPurposeReference, activityReference} = this.props
        const {transientCategories} = this.state

        if (expanded) {
            const update = openingTicketPurposeActionUpdate(openingTicketPurpose)
            dispatch(updateUpdateOpeningTicketPurposeAction(update))

            const openingTicketPurposeCategories = openingTicketPurpose.categories.reduce(categoryAggregator(openingTicketPurposeReference), [])
            const openingTicketPurposeTags = openingTicketPurpose.tags.reduce(tagAggregator(openingTicketPurposeReference), [])
            const openingTicketPurposeActivities = openingTicketPurpose.activities.reduce(activityAggregator(activityReference), [])
            this.setState({openingTicketPurposeCategories, openingTicketPurposeTags, openingTicketPurposeActivities})
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.expanded != this.props.expanded ||
            nextProps.openingTicketPurpose != this.props.openingTicketPurpose) {
            const {dispatch, expanded, openingTicketPurpose, openingTicketPurposeReference, activityReference} = nextProps
            const {transientCategories} = this.state

            if (expanded) {
                const update = openingTicketPurposeActionUpdate(openingTicketPurpose)
                dispatch(updateUpdateOpeningTicketPurposeAction(update))

                const openingTicketPurposeCategories = openingTicketPurpose.categories.reduce(categoryAggregator(openingTicketPurposeReference), [])
                const openingTicketPurposeTags = openingTicketPurpose.tags.reduce(tagAggregator(openingTicketPurposeReference), [])
                const openingTicketPurposeActivities = openingTicketPurpose.activities.reduce(activityAggregator(activityReference), [])
                this.setState({openingTicketPurposeCategories, openingTicketPurposeTags, openingTicketPurposeActivities})
            }
        }
    }

    _sendAction(event) {
        const {dispatch} = this.props

        return dispatch(sendUpdateOpeningTicketPurposeAction()).then(() => {
            return dispatch(loadOpeningTicketPurposeRef())
        })
    }

    _sendAddRemoveTagFromOpeningTicketPurposeAction(action, tag) {
        const {dispatch, openingTicketPurpose} = this.props

        switch(action) {
            case 'Add':
                return dispatch(sendAddTagToOpeningTicketPurposeAction(openingTicketPurpose.uid, tag.uid)).then(() => {
                    return dispatch(loadOpeningTicketPurposeRef())
                })
            case 'Remove':
                return dispatch(sendRemoveTagFromOpeningTicketPurposeAction(openingTicketPurpose.uid, tag.uid)).then(() => {
                    return dispatch(loadOpeningTicketPurposeRef())
                })
        }
    }

    _sendAddRemoveCategoryFromOpeningTicketPurposeAction(action, category) {
        const {dispatch, openingTicketPurpose} = this.props

        switch(action) {
            case 'Add':
                return dispatch(sendAddCategoryToOpeningTicketPurposeAction(openingTicketPurpose.uid, category.uid)).then(() => {
                    return dispatch(loadOpeningTicketPurposeRef())
                })
            case 'Remove':
                return dispatch(sendRemoveCategoryFromOpeningTicketPurposeAction(openingTicketPurpose.uid, category.uid)).then(() => {
                    return dispatch(loadOpeningTicketPurposeRef())
                })
        }
    }

    _submitCreateCategory(event, parentCategory, index) {
        const {onSubmit} = this.props

        const category = {
            label: this._categoryTypeaheadGridInputs[index].getQuery(),
            parent: parentCategory
        }
        
        onSubmit(event, 'CreateCategory', category).then((category) => {
            this._sendAddRemoveCategoryFromOpeningTicketPurposeAction('Add', category)
        })
    }

    _submitCreateTag(event) {
        const {onSubmit} = this.props
        
        const tag = {
            label: this._tagTypeaheadGridInput.getQuery()
        }

        onSubmit(event, 'CreateTag', tag).then((tag) => {
            this._sendAddRemoveTagFromOpeningTicketPurposeAction('Add', tag)
        })
    }

    render() {
        const {dispatch, form, action, openingTicketPurpose, openingTicketPurposeReference, activityReference, onSubmit, ...others} = this.props
        const {openingTicketPurposeCategories, openingTicketPurposeTags, openingTicketPurposeActivities, transientCategories} = this.state

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const categorySource = (category) => {
            return matcher({
                source: openingTicketPurposeReference.categories.filter(childrenCategoryFilter(category)),
                identify: (c) => c.label
            })
        }

        const tagSource = matcher({
            source: openingTicketPurposeReference.tags,
            identify: (t) => t.label
        })

        const header = (
            <h5 className={style.header}>
                {!openingTicketPurpose.enabled && (
                    <Icon icon='closed' size='sm' />
                )}
                <span>{openingTicketPurpose.label}</span>
            </h5>
        )

        const tooltipInputAddon = (text) => (
            <OverlayTrigger
                placement='bottom'
                overlay={tooltip(text)}>
                <span className={style.info}>?</span>
            </OverlayTrigger>
        )

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-primary'>
                {text}
            </Tooltip>
        )

        const displayCategory = (category, active, path) => (
            <div className={style.category}>
                <IconCateg iconId={category.iconId} exponent={active && 'X'}/>
                <label>{category.label}</label>
                {path && (
                    <small>></small>
                )}
            </div>
        )

        const displayTag = (tag, active) => {
            return (
                <div className={style.tag}>
                    <IconCateg iconId={tag.iconId} exponent={active && 'X'}/>
                    <label>{tag.label}</label>
                </div>
            )
        }

        const activityElement = (activity) => (
            <li
                key={activity.uid}>
                <a
                    href=''
                    onClick={(e) => onSubmit(e, 'DissociateActivityFromOpeningTicketPurpose', {openingTicketPurpose, activity})}>
                    <Icon icon='minus' size='xs' />
                </a>
                <p>{activity.label}</p>
            </li>
        )

        const categoryPathField = (category) => {
            const value = OpeningTicketPurposeRef.expendParentCategories(openingTicketPurposeReference, category)

            const disabled = (category, index) => {
                return index < value.length - 1
            }

            const onSubmit = (action, category) => {
                this._sendAddRemoveCategoryFromOpeningTicketPurposeAction(action, category)
            }

            return {value, disabled, onSubmit}
        }

        const transientCategoryPathField = (category) => {
            const index = transientCategories.indexOf(category)
            const value = OpeningTicketPurposeRef.expendParentCategories(openingTicketPurposeReference, category)

            const disabled = (category, index) => {
                return index < value.length - 1
            }

            const onChange = (categories) => {
                const nextCategory = OpeningTicketPurposeRef.getLeafCategory(categories)
                const nextTransientCategories = [...transientCategories]
                
                if (nextCategory) {
                    nextTransientCategories[index] = nextCategory
                } else {
                    nextTransientCategories.splice(index, 1)
                }

                this.setState({transientCategories: nextTransientCategories})
            }

            return {value, disabled, onChange}
        }

        const addRemoveTransientCategory = (next, category) => {
            const index = transientCategories.indexOf(category)

            return (action, category) => {
                switch(action) {
                    case 'Add':
                        if (openingTicketPurposeCategories.find(onPathFinder(openingTicketPurposeReference, category))) {
                            const nextTransientCategories = [...transientCategories]

                            if (index < 0) {
                                nextTransientCategories.push(category)
                            } else {
                                nextTransientCategories[index] = category
                            }

                            this.setState({transientCategories: nextTransientCategories})
                            return
                        }

                        return next(action, category).then(() => {
                            if (index >= 0) {
                                const nextTransientCategories = [...transientCategories]
                                nextTransientCategories.splice(index, 1)

                                this.setState({transientCategories: nextTransientCategories})
                            }
                        })
                    case 'Remove':
                        return next(action, category)
                }
            }
        }

        const closeTagTagBar = (next) => {
            return (...args) => {
                this._tagTagBar.close()
                return next(...args)
            }
        }

        const closeCategoryTagBar = (next, index) => {
            return (...args) => {
                this._categoryTagBars[index] && this._categoryTagBars[index].close()
                return next(...args)
            }
        }

        return (
            <Panel
                header={header}
                {...others}>
                <div className={style.defaultContent}>
                    <form className='form-horizontal'>
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='label'
                            label={requiredLabel(i18n.label)}
                            {...form.label()} />
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='reference'
                            label={i18n.reference}
                            addonAfter={tooltipInputAddon(i18n.referenceInfo)}
                            {...form.extId()} />
                    </form>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendAction() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                    </ButtonToolbar>
                    <Row>
                        <Col sm={3}>
                            <h5>{i18n.categories}</h5>
                        </Col>
                        <Col sm={9}>
                            {openingTicketPurposeCategories.slice(0).reverse().map((category, index) => (
                                <div
                                    className={style.categoryTagSection}
                                    key={index}>
                                    <TagBar multi
                                        ref={(tb) => this._categoryTagBars[index] = tb}
                                        display={(c, i, a) => displayCategory(c, i == a.length - 1, true)}
                                        identify={(c) => c.uid}
                                        label={i18n.addChildCategory}
                                        {...categoryPathField(category)}>
                                        <TypeaheadGridInput
                                            ref={(tgi) => this._categoryTypeaheadGridInputs[index] = tgi}
                                            source={categorySource(category)}
                                            identify={(c) => c.uid}
                                            display={displayCategory}
                                            placeholder={i18n.searchCategory}
                                            value={category}
                                            onSubmit={closeCategoryTagBar((a, c) => this._sendAddRemoveCategoryFromOpeningTicketPurposeAction(a, c), index)} />
                                        <div className={style.manage}>
                                            <a
                                                href=''
                                                onClick={closeCategoryTagBar((e) => this._submitCreateCategory(e, category, index), index)}>
                                                {i18n.newCategory}
                                            </a>
                                        </div>
                                    </TagBar>
                                </div>
                            ))}
                            {transientCategories.map((category, index) => (
                                <div
                                    className={cx(style.categoryTagSection, style.transient)}
                                    key={index}>
                                    <TagBar multi
                                        ref={(tb) => this._categoryTagBars[100 + index] = tb}
                                        display={(c, i, a) => displayCategory(c, i == a.length - 1, true)}
                                        identify={(c) => c.uid}
                                        label={i18n.addChildCategory}
                                        {...transientCategoryPathField(category)}>
                                        <TypeaheadGridInput
                                            ref={(tgi) => this._categoryTypeaheadGridInputs[100 + index] = tgi}
                                            source={categorySource(category)}
                                            identify={(c) => c.uid}
                                            display={displayCategory}
                                            placeholder={i18n.searchCategory}
                                            value={category}
                                            onSubmit={closeCategoryTagBar(addRemoveTransientCategory((a, c) => this._sendAddRemoveCategoryFromOpeningTicketPurposeAction(a, c), category), 100 + index)} />
                                        <div className={style.manage}>
                                            <a
                                                href=''
                                                onClick={closeCategoryTagBar((e) => this._submitCreateCategory(e, category, 100 + index), 100 + index)}>
                                                {i18n.newCategory}
                                            </a>
                                        </div>
                                    </TagBar>
                                </div>
                            ))}
                            <div className={style.categoryTagSection}>
                                <TagBar
                                    ref={(tb) => this._categoryTagBars[1000] = tb}
                                    value={null}
                                    label={i18n.addCategory}>
                                    <TypeaheadGridInput
                                        ref={(tgi) => this._categoryTypeaheadGridInputs[1000] = tgi}
                                        source={categorySource()}
                                        identify={(c) => c.uid}
                                        display={displayCategory}
                                        placeholder={i18n.searchCategory}
                                        value={null}
                                        onSubmit={closeCategoryTagBar(addRemoveTransientCategory((a, c) => this._sendAddRemoveCategoryFromOpeningTicketPurposeAction(a, c)), 1000)} />
                                    <div className={style.manage}>
                                        <a
                                            href=''
                                            onClick={closeCategoryTagBar((e) => this._submitCreateCategory(e, null, 1000), 1000)}>
                                            {i18n.newCategory}
                                        </a>
                                    </div>
                                </TagBar>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={3}>
                            <h5>{i18n.tags}</h5>
                        </Col>
                        <Col sm={9}>
                            <div className={style.categoryTagSection}>
                                <TagBar multi
                                    ref={(tb) => this._tagTagBar = tb}
                                    display={(t) => displayTag(t, true)}
                                    identify={(t) => t.uid}
                                    label={i18n.addTag}
                                    value={openingTicketPurposeTags}
                                    onSubmit={(a, t) => this._sendAddRemoveTagFromOpeningTicketPurposeAction(a, t)}>
                                    <TypeaheadGridInput multi
                                        ref={(tgi) => this._tagTypeaheadGridInput = tgi}
                                        source={tagSource}
                                        identify={(t) => t.uid}
                                        display={displayTag}
                                        placeholder={i18n.searchTag}
                                        value={openingTicketPurposeTags}
                                        onSubmit={closeTagTagBar((a, t) => this._sendAddRemoveTagFromOpeningTicketPurposeAction(a, t))} />
                                    <div className={style.manage}>
                                        <a
                                            href=''
                                            onClick={closeTagTagBar((e) => this._submitCreateTag(e))}>
                                            {i18n.newTag}
                                        </a>
                                    </div>
                                </TagBar>
                            </div>
                        </Col>
                    </Row>
                    <div className={style.activities}>
                        <div className={style.action}>
                            <OverlayTrigger
                                placement='bottom'
                                overlay={tooltip(i18n.associateActivity)}>
                                <Button
                                    href=''
                                    bsStyle='link'
                                    onClick={(e) => onSubmit(e, 'AssociateActivityWithOpeningTicketPurpose', openingTicketPurpose)}>
                                    <Icon icon='plus' size='xs' />
                                </Button>
                            </OverlayTrigger>
                        </div>
                        <Row>
                            <Col sm={6}>
                                <ul>
                                    {openingTicketPurposeActivities.slice(0, openingTicketPurposeActivities.length / 2 + 1).map(activityElement)}
                                </ul>
                            </Col>
                            <Col sm={6}>
                                <ul>
                                    {openingTicketPurposeActivities.slice(openingTicketPurposeActivities.length / 2 + 1, openingTicketPurposeActivities.length).map(activityElement)}
                                </ul>
                            </Col>
                        </Row>
                    </div>
                    <div className={style.disable}>
                        <a
                            href=''
                            onClick={(e) => onSubmit(e, 'EnableDisableOpeningTicketPurpose', openingTicketPurpose)}>
                            {openingTicketPurpose.enabled &&i18n.disableOpeningTicketPurpose || i18n.enableOpeningTicketPurpose}
                        </a>
                    </div>
                </div>
            </Panel>
        )
    }
}

UpdateOpeningTicketPurposePanel = connectForm({
    target: 'action',
    schema: UpdateOpeningTicketPurposeAction.schema,
    action: UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED
})(UpdateOpeningTicketPurposePanel)

UpdateOpeningTicketPurposePanel = connect((state) => ({
    action: state.reference.updateOpeningTicketPurposeAction
}))(UpdateOpeningTicketPurposePanel)

export default UpdateOpeningTicketPurposePanel


// WEBPACK FOOTER //
// ./lib/reference/components/UpdateOpeningTicketPurposePanel.js